import type { ReactNode } from "react";
import { cn } from "./cn";

/** A word in a heading set in the primary green over a slanted ink bar, scaled to the heading's own size. */
export function Highlight({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        "relative inline-block whitespace-nowrap text-primary",
        "after:absolute after:inset-x-[0.02em] after:-bottom-[0.04em] after:h-[0.13em] after:-skew-x-[20deg] after:bg-accent after:content-['']",
        className,
      )}
    >
      {children}
    </span>
  );
}
